export const STATIC_PATH = '/node_modules/@sitesee/scene-viewer/static';
export const TEST_API_URL = process.env.BIM_API_URL;
